export default {
	huanyinghuilai: '欢迎回来',
	wodezhanghu: '我的帐户',
	gerenxinxi: '个人信息',
	jiatingyupengyou: '家庭和朋友',
	fukuanshijian: '支付时间',
	fukuanfangshi: '支付方式',
	fukuanjine: '支付金额',
	genggaimima: '更改密码',
	quebaoxinxizhengque: '请确保所有信息都是正确的。所有头衔和乘客姓名必须完全按照您护照或其他有效旅行证件上的显示输入。',
	zhuxiao: '退出登录',
	quedingyaodengchuma: '确定要退出登录吗？',
	tuichuchenggong: '退出成功!',
	nishifeixingchangkema: '是否飞行常客会员？',
	lijitianjianindejiarenhepengyou: '立即添加您的家人和朋友',
	tianjianindepengyou: '添加您的朋友和家人的詳細資訊，以加快預訂過程。',
	xinzeng: '新增',
	lijitianjiaka: '立即添加卡',
	tianjiaka: '添加卡以加快预订过程。',
	bianji: '编辑',
	shanchu: '删除',
	querenshanchuchengkexinxime: '确认删除该乘客信息么?'
};
